/* eslint-disable no-undef */

/**
 *  This file automatically imports all the svg files in this folder and exports them as vue components.
 *  The component name and export follows the following pattern: `category-<filename>-icon`
 *
 *  Note: it works in conjunction with the [bl-svg-loader](config/webpack/loaders/bl-svg-loader.js).
 */

let icons = {}

function requireAll(r) {
  r.keys().forEach((key) => {
    const name = "category-" + key.replace(/\.\/|\.svg/g, "") + "-icon"
    if (!name.includes("/")) {
      icons[name] = r(key).default
      icons[name].name = name
    }
  })
}

if (!process || process.env.NODE_ENV !== "test") {
  requireAll(require.context("./", true, /\.svg$/));
}

module.exports = {
  ...icons
};
